import { render, staticRenderFns } from "./TableQuiz.vue?vue&type=template&id=33d3dca4&scoped=true&"
import script from "./TableQuiz.vue?vue&type=script&lang=js&"
export * from "./TableQuiz.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./TableQuiz.vue?vue&type=style&index=1&id=33d3dca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3dca4",
  null
  
)

export default component.exports